import { Button } from 'components/Button'
import { useRouter } from 'next/router'
import { apiRequest } from '../util/util'
import { useEffect, useState } from 'react'
import PageLoader from 'components/PageLoader'
const ConfirmSignup = () => {
  const router = useRouter()
  const { confirmation_url, token, email } = router.query
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const confirm = async () => {
      await fetch('/api/confirm-signup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          confirmation_url,
        }),
      })
      setLoading(false)
    }
    if (router.isReady && confirmation_url) confirm()
  }, [confirmation_url, router.isReady])

  const handleConfirm = async () => {
    if (!token || !email) return
    await apiRequest('otp-confirm', 'POST', {
      token,
      email,
    })
    router.push('/dashboard')
  }

  return (
    <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
      {loading && (
        <div className="flex justify-center">
          <PageLoader />
        </div>
      )}
      {!loading && (
        <div className="text-center">
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            {'Confirm your account'}
          </h1>
          <p className="mt-6 text-base leading-7 text-gray-600">
            {"You're almost there!"}
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Button onClick={handleConfirm}>Confirm Account</Button>
          </div>
        </div>
      )}
    </main>
  )
}

export default ConfirmSignup
